import { useContext } from 'react';

import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import { Helmet } from 'react-helmet-async';

import ImageCoverPage from 'components/ImageCoverPage';

import { SchoolContext } from 'context/SchoolContext';

import Form from './components/Form';

function ForgotPasswordCover(): JSX.Element {
  const schoolContext = useContext(SchoolContext);
  return (
    <ImageCoverPage imgSrc={schoolContext?.loginImage}>
      <Helmet>
        <title>Forgot Password</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Fade in timeout={500}>
        <Box>
          <Form />
        </Box>
      </Fade>
    </ImageCoverPage>
  );
}

export default ForgotPasswordCover;
